const globalCache = [];
function handleAsset(fn, cache, throwError, url, proto) {
    for (const entry of cache) {
        // Find a match
        if (url === entry.url) {
            // If an error occurred, throw
            if (entry.error && throwError)
                throw entry.error;
            // If an error occurred but throwing suppressed, return
            if (entry.error && !throwError)
                return null;
            // If a response was successful, return
            if (entry.response)
                return entry.response;
            // If the promise is still unresolved, throw
            throw entry.promise;
        }
    }
    // The request is new or has changed.
    const entry = {
        url,
        proto,
        promise: 
        // Make the promise request.
        fn(proto, url)
            // Response can't be undefined or else the loop above wouldn't be able to return it
            // This is for promises that do not return results (delays for instance)
            .then((response) => (entry.response = (response ?? true)))
            .catch((e) => (entry.error = e ?? new Error('unknown error'))),
    };
    cache.push(entry);
    throw entry.promise;
}
function loadAsset(fn, url, throwError = false, proto) {
    return handleAsset(fn, globalCache, throwError, url, proto);
}
export { loadAsset };
